// extracted by mini-css-extract-plugin
module.exports = {"spotlightLink":"SpotlightForLens_spotlightLink__DoE0R","spotlightLinkLarge":"SpotlightForLens_spotlightLinkLarge__XkXDV","spotlightImage":"SpotlightForLens_spotlightImage__TatX9"};